import React from 'react';
import { Button, Input, Space } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

export const buildBlobPdfUrl = (rawUrl) => {
  if (!rawUrl) return '';
  const filename = String(rawUrl).split(/[?#]/)[0].split('/').pop();
  if (!filename) return '';
  return `${process.env.REACT_APP_STORAGE_URL}${filename}`;
};

export const getStatusFromRecord = (record) => {
  if (record.is_retired) return 'inactive';
  if (record.status === 'batch_processing') return 'in_use';
  if (record.is_cleaned) return 'cleaned';
  return 'to_be_cleaned';
};

export const STATUS_CONFIG = {
  to_be_cleaned: { label: 'To be Cleaned', color: 'orange' },
  cleaned: { label: 'Cleaned', color: 'green' },
  in_use: { label: 'In Use', color: 'blue' },
  inactive: { label: 'Inactive', color: 'default' }
};

export const ACTION_LABELS = {
  label_created: 'Label Generated',
  marked_cleaned: 'Marked as Cleaned',
  assigned_to_batch: 'Assigned to Batch',
  sent_for_cleaning: 'Sent for Cleaning',
  drum_inactivated: 'Drum Inactivated',
  drum_reactivated: 'Drum Reactivated'
};

export const getColumnSearchProps = (dataIndex, getValue) => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters
  }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder="Search"
        value={selectedKeys[0]}
        onChange={(e) =>
          setSelectedKeys(e.target.value ? [e.target.value] : [])
        }
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: 'block', width: 200 }}
      />
      <Space>
        <Button
          type="primary"
          onClick={() => confirm()}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button
          onClick={() => {
            clearFilters();
            confirm();
          }}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered) => (
    <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
  ),
  onFilter: (value, record) => {
    const cell = getValue ? getValue(record) : record[dataIndex];
    if (cell == null) return false;
    return cell.toString().toLowerCase().includes(value.toLowerCase());
  }
});
